import { render, staticRenderFns } from "./MapTable.vue?vue&type=template&id=72ae04cf&scoped=true"
import script from "./MapTable.vue?vue&type=script&lang=js"
export * from "./MapTable.vue?vue&type=script&lang=js"
import style0 from "./MapTable.vue?vue&type=style&index=0&id=72ae04cf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ae04cf",
  null
  
)

export default component.exports